// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from "axios";
import router from './router'
import SideBarComponent from '@/components/SideBarComponent.vue'
import HeaderComponent from '@/components/HeaderComponent.vue'
import SubTitleComponent from '@/components/SubTitleComponent.vue'

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

// import VConsole from 'vconsole';
// new VConsole()

// document.documentElement.requestFullscreen(); // 请求全屏显示

// screen.orientation.lock('landscape').catch((error) => {
//   console.error('Unable to lock screen orientation:', error);
// }); // 尝试锁定为横屏模式，并处理可能的错误。

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  vm.$message.error(err.toString())
  console.log(err.toString(),info)
}

// 挂载到 Vue 原型链
Vue.prototype.$axios = axios;
// Vue.prototype.globalData = globalParams;
// Vue.prototype.setSession = setSession;

const _android = /android/i.test(navigator.userAgent);

console.log('isAndroid', _android)

if(_android){
  console.log('isAndroid', window)
}

Vue.prototype.global = {
  type: 'manage',
  clientId: '',
  clientName: '',
  money: 0,
  isAndroid: _android
}

// Vue.prototype.global = {
//   type: 'client',
//   clientId: '1',
//   clientName: '酷狗',
// }

console.log('prototype', Vue.prototype.global)

Vue.use(ElementUI)

Vue.component('SideBarComponent', SideBarComponent) // 侧边栏组件
Vue.component('HeaderComponent', HeaderComponent) // 头部组件
Vue.component('SubTitleComponent', SubTitleComponent) // 页面标题组件

// let _ckeck = checkLogin()
// console.log(_ckeck)

let instance = axios.create({
  transformRequest: [function (data) {
    // 将数据转换为表单数据
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// process.env.NODE_ENV === 'development' ? '开发环境' : '生产环境'
// console.log(process.env.NODE_ENV)

// 添加请求拦截器
instance.interceptors.request.use(
  config => {
    // 从本地存储获取token
    console.log(process.env.NODE_ENV, config.url)
    if(process.env.NODE_ENV === 'production-ailo' || process.env.NODE_ENV === 'production'){
      if (config.url.startsWith('/api/')) {
        // 移除 '/api/' 前缀
        config.url = config.url.replace('/api/', 'https://api.ylw.s136.ailo.vip/');
      }
    }
    if(process.env.NODE_ENV === 'production-ylwai'){
      if (config.url.startsWith('/api/')) {
        // 移除 '/api/' 前缀
        config.url = config.url.replace('/api/', 'https://mohe-api.s110.ylwai.cn/');
      }
    }
    const token = localStorage.getItem('sessionId');
    console.log('headers1', config.headers)
    if (token) {
      config.headers.Authorization = token; // 动态设置认证header
    }
    // 添加自定义header
    // config.headers['X-Custom-Header'] = 'dynamic-value';
    console.log('request config', config)
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    console.log('response', response)
    if(response.data.errcode != 0){
      if(response.data.error == '请先登录'){
        setTimeout(() => {
          // window.location.href = '/login'
          this.$router.replace('/login')
        }, 1000)
      }
      Vue.prototype.$message.error(response.data.error);
    }
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

// Vue.use(instance);
// 挂载到 Vue 原型链（组件内通过 this.$http 调用）
Vue.prototype.axios = instance

let _path = window.location.pathname
// console.log('path', _path)

try {
	uni.setStorageSync('storage_key', 'hello');
} catch (e) {
	// error
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    const _url = "/api/?mod=user"
    // console.log(_url)
    instance.post(_url).then(json => {
      // 获取
      let _data = json.data.data
      console.log("checklogin", _data);
      if(_data.login == 1){
        Vue.prototype.global.money = _data.user.money
        console.log('user', Vue.prototype.global)
        return
      }
      localStorage.removeItem('sessionId');
      if(_path != '/login'){
        this.$router.replace('/login')
        // window.location.href = '/login'
      }
      console.log(json.data);
    })
  }
})

export default Vue;


// WEBPACK FOOTER //
// ./src/main.js